import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import Section from './Section';
import Timeline from './Timeline';
import { experience } from '../../data/profile';

export default function Experience() {
    const items = experience.map((e) => ({ ...e, title: e.role, subtitle: e.company }));
    return (
        <Section id="experiencia" eyebrow="Perfil laboral" title="Experiencia">
            <Timeline items={items} icon={<WorkOutlineIcon />} />
        </Section>
    );
}
